export default __webpack_public_path__ + "9563737c82b53073f4e297af75dc6325.svg";